import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-18f4dff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-white small text-center robotofonts w-100 container-fluid p-0 py-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2 d-flex justify-content-center cprtext" }, "Featured On", -1))
const _hoisted_3 = { class: "marquee-container" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"badge\" data-v-18f4dff5><a href=\"https://twelve.tools\" target=\"_blank\" data-v-18f4dff5><img src=\"https://twelve.tools/badge3-dark.svg\" alt=\"Featured on Twelve Tools\" data-v-18f4dff5></a></div><div class=\"badge\" data-v-18f4dff5><a href=\"https://wired.business\" target=\"_blank\" data-v-18f4dff5><img src=\"https://wired.business/badge2-dark.svg\" alt=\"Featured on Wired Business\" data-v-18f4dff5></a></div><div class=\"badge\" data-v-18f4dff5><a href=\"https://askaiforit.com/\" target=\"_blank\" data-v-18f4dff5><img src=\"https://askaiforit.com/badges/badge-3.svg\" alt=\"Listed on Ask AI For IT\" data-v-18f4dff5></a></div><div class=\"badge\" data-v-18f4dff5><a href=\"https://startupfa.me/s/techtitans?utm_source=techtitans.cloud\" target=\"_blank\" data-v-18f4dff5><img src=\"https://startupfa.me/badges/featured/dark.webp\" alt=\"Techtitans Hub - Featured on Startup Fame\" data-v-18f4dff5></a></div>", 4)
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "badge" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://projecthunt.me",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "ph-badge",
      viewBox: "0 0 180 48",
      role: "img",
      "aria-label": "Featured on: projecthunt.me"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "Featured on projecthunt.me"),
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        rx: "4",
        fill: "#000",
        stroke: "#E85C0D",
        "stroke-width": "1.5"
      }),
      /*#__PURE__*/_createElementVNode("g", { transform: "translate(10, 8)" }, [
        /*#__PURE__*/_createElementVNode("image", {
          href: "https://projecthunt.me/favicon.ico",
          width: "32",
          height: "32"
        })
      ]),
      /*#__PURE__*/_createElementVNode("g", {
        fill: "#666666",
        "text-anchor": "start",
        "font-family": "Verdana, Geneva, DejaVu Sans, sans-serif"
      }, [
        /*#__PURE__*/_createElementVNode("text", {
          x: "50",
          y: "20",
          "font-size": "13",
          "font-weight": "500"
        }, "Featured on"),
        /*#__PURE__*/_createElementVNode("text", {
          x: "50",
          y: "36",
          "font-size": "14",
          "font-weight": "600",
          fill: "#E85C0D"
        }, "projecthunt.me")
      ])
    ])
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"badge\" data-v-18f4dff5><a href=\"https://startuptrusted.com?ref=techtitans.cloud\" target=\"_blank\" rel=\"noopener\" data-v-18f4dff5><img src=\"https://startuptrusted.com/api/badge?type=featured&amp;style=dark\" alt=\"TechTitans on StartupTrusted\" data-v-18f4dff5></a></div><div class=\"badge\" data-v-18f4dff5><a href=\"https://fazier.com\" target=\"_blank\" data-v-18f4dff5><img src=\"https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=featured&amp;theme=dark\" alt=\"Fazier badge\" data-v-18f4dff5></a></div>", 2)
const _hoisted_11 = [
  _hoisted_4,
  _hoisted_8,
  _hoisted_9
]

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Badges',
  setup(__props) {

const track = ref < HTMLElement | null > (null);

onMounted(() => {
	const el = track.value;
	if (!el) return;

	// κλωνοποιεί το περιεχόμενο για seamless loop
	el.innerHTML += el.innerHTML;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "marquee-track",
        ref_key: "track",
        ref: track
      }, _hoisted_11, 512)
    ])
  ]))
}
}

})